import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CheckSquare, FilePlus2, FileText, FolderKanban, Plus, Search, ShieldCheck, User } from "lucide-react";
import { Command, CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator } from "./ui/command";
import api from "../lib/api";

export default function CommandPalette({ open, setOpen }) {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState(null);

  useEffect(() => {
    if (!open) { setQuery(""); setResults(null); }
  }, [open]);

  useEffect(() => {
    if (query.length < 2) { setResults(null); return; }
    const t = setTimeout(async () => {
      try {
        const r = await api.get("/search", { params: { q: query } });
        setResults(r.data);
      } catch { setResults(null); }
    }, 250);
    return () => clearTimeout(t);
  }, [query]);

  const go = (path) => { setOpen(false); navigate(path); };

  return (
    <CommandDialog open={open} onOpenChange={setOpen} data-testid="command-palette">
      <CommandInput placeholder="Buscar expedientes, documentos, usuarios… o ejecutar una acción" value={query} onValueChange={setQuery} data-testid="command-palette-input" />
      <CommandList>
        <CommandEmpty>No hay resultados para «{query}».</CommandEmpty>
        <CommandGroup heading="Acciones">
          <CommandItem onSelect={() => go("/expedientes?nuevo=1")} data-testid="cmd-create-expediente"><Plus className="mr-2 h-4 w-4" /> Crear expediente</CommandItem>
          <CommandItem onSelect={() => go("/mi-trabajo?nueva=1")} data-testid="cmd-create-task"><FilePlus2 className="mr-2 h-4 w-4" /> Crear tarea</CommandItem>
          <CommandItem onSelect={() => go("/mi-trabajo")} data-testid="cmd-mi-trabajo"><CheckSquare className="mr-2 h-4 w-4" /> Ir a Mi trabajo</CommandItem>
          <CommandItem onSelect={() => go("/aprobaciones")} data-testid="cmd-aprobaciones"><ShieldCheck className="mr-2 h-4 w-4" /> Ir a Aprobaciones</CommandItem>
          <CommandItem onSelect={() => go("/buscar")} data-testid="cmd-buscar"><Search className="mr-2 h-4 w-4" /> Búsqueda global</CommandItem>
          <CommandItem onSelect={() => go("/")} data-testid="cmd-notificaciones"><Bell className="mr-2 h-4 w-4" /> Abrir notificaciones</CommandItem>
        </CommandGroup>
        {results && (
          <>
            <CommandSeparator />
            {results.expedientes.length > 0 && (
              <CommandGroup heading="Expedientes">
                {results.expedientes.map((e) => (
                  <CommandItem key={e.id} onSelect={() => go(`/expedientes/${e.id}`)} data-testid={`cmd-exp-${e.id}`}>
                    <FolderKanban className="mr-2 h-4 w-4" /> <span className="font-mono text-xs text-slate-400">{e.code}</span>&nbsp;{e.title}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
            {results.documentos.length > 0 && (
              <CommandGroup heading="Documentos">
                {results.documentos.map((d) => (
                  <CommandItem key={d.id} onSelect={() => go("/documentos")} data-testid={`cmd-doc-${d.id}`}>
                    <FileText className="mr-2 h-4 w-4" /> {d.name}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
            {results.usuarios.length > 0 && (
              <CommandGroup heading="Usuarios">
                {results.usuarios.map((u) => (
                  <CommandItem key={u.id} onSelect={() => go(`/mi-trabajo?responsable=${u.id}`)} data-testid={`cmd-user-${u.id}`}>
                    <User className="mr-2 h-4 w-4" /> {u.name} — {u.title}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
          </>
        )}
      </CommandList>
    </CommandDialog>
  );
}
